import { Link } from "react-router-dom";
import SvnLogo from "@/components/SvnLogo";
import { Youtube, Facebook, Music2, Podcast, Instagram } from "lucide-react";
import { useSettings } from "@/contexts/SettingsContext";

export default function Footer() {
  const { settings } = useSettings();
  return (
    <footer className="border-t border-white/10 bg-[#050505] mt-24" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <SvnLogo size="md" />
          <p className="mt-4 text-sm text-neutral-400 font-body max-w-xs">
            Signal Voice Network. Different Voices. One Signal. Real conversations across sports, food, culture, business and beyond.
          </p>
          {settings.contact_email && (
            <a href={`mailto:${settings.contact_email}`} className="mt-3 inline-block text-xs text-neutral-400 hover:text-gold">
              {settings.contact_email}
            </a>
          )}
        </div>

        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold mb-4">Network</p>
          <ul className="space-y-2 text-sm text-neutral-300">
            <li><Link className="hover:text-white" to="/shows">Shows</Link></li>
            <li><Link className="hover:text-white" to="/episodes">Episodes</Link></li>
            <li><Link className="hover:text-white" to="/espanol">SVN Español</Link></li>
            <li><Link className="hover:text-white" to="/sponsors">Sponsors</Link></li>
            <li><Link className="hover:text-white" to="/membership">Membership</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold mb-4">Company</p>
          <ul className="space-y-2 text-sm text-neutral-300">
            <li><Link className="hover:text-white" to="/about">About</Link></li>
            <li><Link className="hover:text-white" to="/contact">Contact</Link></li>
            <li><Link className="hover:text-white" to="/admin/login">Admin</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold mb-4">Watch & Listen</p>
          <div className="flex items-center gap-4 flex-wrap">
            {settings.youtube_url && (
              <a href={settings.youtube_url} target="_blank" rel="noreferrer" aria-label="YouTube" className="text-neutral-300 hover:text-svn-red transition" data-testid="footer-social-youtube"><Youtube size={22} /></a>
            )}
            {settings.spotify_url && (
              <a href={settings.spotify_url} target="_blank" rel="noreferrer" aria-label="Spotify" className="text-neutral-300 hover:text-svn-red transition" data-testid="footer-social-spotify"><Music2 size={22} /></a>
            )}
            {settings.apple_podcasts_url && (
              <a href={settings.apple_podcasts_url} target="_blank" rel="noreferrer" aria-label="Apple Podcasts" className="text-neutral-300 hover:text-svn-red transition" data-testid="footer-social-apple"><Podcast size={22} /></a>
            )}
            {settings.facebook_url && (
              <a href={settings.facebook_url} target="_blank" rel="noreferrer" aria-label="Facebook" className="text-neutral-300 hover:text-svn-red transition" data-testid="footer-social-facebook"><Facebook size={22} /></a>
            )}
            {settings.instagram_url && (
              <a href={settings.instagram_url} target="_blank" rel="noreferrer" aria-label="Instagram" className="text-neutral-300 hover:text-svn-red transition" data-testid="footer-social-instagram"><Instagram size={22} /></a>
            )}
          </div>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-neutral-500">
          <p>© {new Date().getFullYear()} {settings.footer_text || "SVN Network. All rights reserved."} SVNLive.com</p>
          <p className="uppercase tracking-[0.3em]">Different Voices. <span className="text-gold">One Signal.</span></p>
        </div>
      </div>
    </footer>
  );
}
